<script>
export default {
    data() {
        return {
            data: {},
        };
    },
    created() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();
            vm.create();
        },
        newData() {
            var vm = this;

            var data = {
                store: null,
                branch: null,
                user: null,
                action: null,
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('employee_invite_create');
            try {
                var resp = await this.$api.EmployeeInvite.get(vm.$route.params.id);
                var data = resp.data.data;

                vm.data = data;
            } catch (err) {
                this.$flash.error(err.response.data.message);

                var api_token = vm.$api.getApiToken();
                var is_login = api_token !== undefined && api_token !== null && api_token !== "";

                if (is_login) {
                    vm.$router.push({ name: '/' });
                    vm.$ac.refresh();
                } else {
                    vm.$router.push({ name: 'login' });
                }
            }

            this.$loading.off('employee_invite_create');
        },
        async submit() {
            var vm = this;
            this.$loading.on('employee_invite_submit');

            try {
                var postData = {
                    id: vm.$route.params.id,
                };
                var resp = await this.$api.EmployeeInvite.create(postData);
                var data = resp.data;

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }

            var api_token = vm.$api.getApiToken();
            var is_login = api_token !== undefined && api_token !== null && api_token !== "";

            if (is_login) {
                vm.$router.push({ name: '/' });
                vm.$ac.refresh();
            } else {
                vm.$router.push({ name: 'login' });
            }

            this.$loading.off('employee_invite_submit');
        }
    }
}
</script>

<template>
    <loading :loading="$loading.get('employee_invite_create')" variant="dark" type="block">
        <div class="auth-page-wrapper pt-5">
            <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
                <div class="bg-overlay"></div>

                <div class="shape">

                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 1440 120">
                        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z">
                        </path>
                    </svg>
                </div>
            </div>

            <div class="auth-page-content">
                <BContainer>
                    <BRow>
                        <BCol lg="12">
                            <div class="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                                    <router-link to="/" class="d-inline-block auth-logo">
                                        <img src="@/assets/images/logo-light.png" alt="" height="40" />
                                    </router-link>
                                </div>
                            </div>
                        </BCol>
                    </BRow>

                    <BRow class="justify-content-center">
                        <BCol md="8" lg="6" xl="5">
                            <BCard no-body class="mt-4">
                                <BcardBody class="p-4 text-center">
                                    <div class="avatar-lg mx-auto mt-2">
                                        <div class="
                      avatar-title
                      bg-light
                      text-success
                      display-3
                      rounded-circle
                    ">
                                            <i class="mdi mdi-account-tie-outline"></i>
                                        </div>
                                    </div>
                                    <div class="mt-4 pt-2">
                                        <h4>{{ $t('employee.invite.form.header', { user: data.user }) }}</h4>
                                        <p class="text-muted mx-4">
                                            {{ $t('employee.invite.form.body', { store: data.store, branch: data.branch }) }}
                                        </p>
                                        <div class="mt-4">
                                            <BButton type="submit" variant="success" class="w-100" @click="submit"
                                                :disabled="$loading.get('employee_invite_submit')">
                                                <loading :loading="$loading.get('employee_invite_submit')">
                                                    {{ $t('employee.btn.join') }}
                                                </loading>
                                            </BButton>
                                        </div>
                                    </div>
                                </BcardBody>
                            </BCard>
                        </BCol>
                    </BRow>
                </BContainer>
            </div>

            <footer class="footer">
                <BContainer>
                    <BRow>
                        <BCol lg="12">
                            <div class="text-center">
                                <p class="mb-0">&copy; 2026 Cafeman. Seluruh Hak Cipta Dilindungi.</p>
                            </div>
                        </BCol>
                    </BRow>
                </BContainer>
            </footer>
        </div>
    </loading>
</template>